import { createDataSelectors } from "@app/modules/app.reducers";
import { Guard } from "@ea/shared_types/types";

export const guardDataSelectors = createDataSelectors<Guard>()("guards");
